const STORAGE_KEY = 'redesign_newsletter_popup'
const DISMISS_TTL = 24 * 60 * 60 * 1000
const ACTIVE_CLASS = 'redesign-popup--active'
const CLOSE_SELECTOR = '[data-popup-close]'
const SUCCESS_SELECTOR = '[data-newsletter-message][class*="--success"]'

class RedesignNewsletterPopup {
  constructor (el) {
    this.el = el
    this.threshold = this._getClickThreshold()
    this.clickCount = 0
    this.isOpen = false
    this.onBodyClick = this.onBodyClick.bind(this)
    this.onRootClick = this.onRootClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
  }

  init () {
    if (!this.el) return

    this.el.addEventListener('click', this.onRootClick)
    document.addEventListener('keydown', this.onKeydown)

    if (this._hasPostedSuccess()) {
      this._writeState({ subscribed: true })
      this.open()
      return
    }

    if (this._isSuppressed()) return

    document.body.addEventListener('click', this.onBodyClick)
  }

  destroy () {
    this.el.removeEventListener('click', this.onRootClick)
    document.removeEventListener('keydown', this.onKeydown)
    document.body.removeEventListener('click', this.onBodyClick)
  }

  open () {
    if (this.isOpen) return

    this.isOpen = true
    this.el.hidden = false
    this.el.classList.add(ACTIVE_CLASS)
  }

  close (options = {}) {
    if (!this.isOpen) return

    this.isOpen = false
    this.el.classList.remove(ACTIVE_CLASS)
    this.el.hidden = true

    if (options.persistDismiss !== false) {
      this._writeState({ dismissedAt: Date.now() })
    }
  }

  onBodyClick () {
    if (this.isOpen || this._isSuppressed()) return

    this.clickCount += 1

    if (this.clickCount >= this.threshold) {
      this.open()
    }
  }

  onRootClick (event) {
    if (!event.target.closest(CLOSE_SELECTOR)) return

    event.preventDefault()
    this.close()
  }

  onKeydown (event) {
    if (!this.isOpen || event.key !== 'Escape') return

    event.preventDefault()
    this.close()
  }

  _getClickThreshold () {
    const parsedThreshold = parseInt(this.el.dataset.clickCount || '', 10)

    return Number.isNaN(parsedThreshold) || parsedThreshold < 1 ? 4 : parsedThreshold
  }

  _readState () {
    try {
      const value = window.localStorage.getItem(STORAGE_KEY)

      if (!value) return {}

      const parsedValue = JSON.parse(value)

      return parsedValue && typeof parsedValue === 'object' ? parsedValue : {}
    } catch (error) {
      return {}
    }
  }

  _writeState (nextState) {
    try {
      const state = this._readState()

      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({
        ...state,
        ...nextState
      }))
    } catch (error) {
      return null
    }
  }

  _isSuppressed () {
    const state = this._readState()

    if (state.subscribed === true) return true

    const dismissedAt = Number(state.dismissedAt)

    if (Number.isNaN(dismissedAt) || dismissedAt <= 0) return false

    return Date.now() - dismissedAt < DISMISS_TTL
  }

  _hasPostedSuccess () {
    return this.el.dataset.posted === 'true' || Boolean(this.el.querySelector(SUCCESS_SELECTOR))
  }
}

export default (el) => {
  if (!el) return null

  const instance = new RedesignNewsletterPopup(el)
  instance.init()
  return instance
}
